module.exports = __webpack_public_path__ + "img/abgc4.da70e7db.jpg";